<form [formGroup]="swotForm">
  <mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'asset-swot'">
    @let isEditable = assetSwotEditable$ | async;
    @let hasWebsiteUrl = hasWebsiteUrl$ | async;
    <mat-card-header class="detail-card-header">
      <mat-card-title data-test="title">SWOT</mat-card-title>
    </mat-card-header>
    @if (selectedAsset$ | async; as selectedAsset) {
      @if (swot$ | async; as swot) {
        <mat-card-subtitle>
          @if (gptSwot$ | async; as gptSwot) {
            @if (gptSwot.status === 'ERROR') {
              <valumize-info-panel [appearance]="'ERROR'" [message]="gptErrorMessage"></valumize-info-panel>
            }
          }
          @if (selectedAsset.status === 'ERROR') {
            <valumize-info-panel [appearance]="'ERROR'" [message]="selectedAsset.errorMessage"></valumize-info-panel>
          }
          @if (selectedAsset.status === 'SAVED') {
            <valumize-info-panel [appearance]="'SAVED'" [message]="'Successfully saved'"></valumize-info-panel>
          }
          @if (selectedAsset.status === 'LOADING') {
            <mat-progress-spinner></mat-progress-spinner>
          }
        </mat-card-subtitle>
        @if (isEditable || swot.swotStrengths.text || swot.swotWeaknesses.text || swot.swotOpportunities.text || swot.swotThreats.text) {
          <mat-card-content class="detail-card-content">
            <div class="swot-form">
              <div class="swot-textarea">
                <h3 data-test="strengths-label">Strengths</h3>
                <ng-container *ngTemplateOutlet="swotTemplate; context: { swotControl: 'swotStrengths' }"></ng-container>
              </div>
              <div class="swot-textarea">
                <h3 data-test="strengths-label">Weaknesses</h3>
                <ng-container *ngTemplateOutlet="swotTemplate; context: { swotControl: 'swotWeaknesses' }"></ng-container>
              </div>
              <div class="swot-textarea">
                <h3 data-test="strengths-label">Opportunities</h3>
                <ng-container *ngTemplateOutlet="swotTemplate; context: { swotControl: 'swotOpportunities' }"></ng-container>
              </div>
              <div class="swot-textarea">
                <h3 data-test="strengths-label">Threats</h3>
                <ng-container *ngTemplateOutlet="swotTemplate; context: { swotControl: 'swotThreats' }"></ng-container>
              </div>
            </div>
            <ng-template #swotTemplate let-swotControl="swotControl">
              <div class="swot-textarea-container">
                <mat-form-field>
                  <textarea [formControlName]="swotControl" style="height: 200px;" matInput></textarea>
                </mat-form-field>
                @if (gptSwot$ | async; as swot) {
                  @if (isGptEditMode && swot.status !== 'LOADING') {
                    <div class="gpt-actions">
                      <button mat-stroked-button color="primary" (click)="copyGptText(swotControl, swot.data)">Replace</button>
                      <button mat-stroked-button color="primary" (click)="addGptText(swotControl, swot.data)">Append</button>
                    </div>
                  }
                  @if (isGptEditMode && swot.status !== 'LOADING') {
                    <mat-form-field class="gpt-description">
                      <textarea class="line-breaks"
                        [value]="getSwotText(swotControl, swot.data) || ''"
                        matInput
                      readonly></textarea>
                    </mat-form-field>
                  }
                }
              </div>
            </ng-template>
          </mat-card-content>
        } @else {
          <mat-card-content class="detail-card-content">
            <div class="no-content" style="color: grey">Please add content to SWOT.</div>
          </mat-card-content>
        }
      } @else {
        <mat-card-content class="detail-card-content">
          <div class="no-content" style="color: grey">Please add content to SWOT.</div>
        </mat-card-content>
      }
      <mat-card-actions class="detail-card-actions">
        @if ((gptSwot$ | async)?.status === 'LOADING') {
          <mat-spinner diameter="24"></mat-spinner>
        }
        @if (isEditable) {
          <span [matTooltip]="!hasWebsiteUrl ? 'Please fill in the website first' : ''">
            <button mat-icon-button
              (click)="isGptEditMode ? gptCancel() : gptEditMode()"
              [disabled]="!hasWebsiteUrl"
              class="image-button"
              aria-label="Generate SWOT">
              <img src="assets/logo.svg" alt="Valumize AI" />
            </button>
          </span>
        }
        <div class="last-modified" data-test="modification-date">Last modified: {{mostRecentSwotModDate | timestamp}}</div>
        @if (!isEditable) {
          <button mat-icon-button
            color="primary"
            data-test="edit-button"
            (click)="editMode()"
            [disabled]="(isEditDisabled$ | async)!">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (isEditable) {
          <button mat-icon-button color="primary" data-test="save-button" (click)="save(); gptCancel()">
            <mat-icon>save</mat-icon>
          </button>
        }
        @if (isEditable) {
          <button mat-icon-button color="primary" data-test="cancel-button" (click)="cancel(); gptCancel()">
            <mat-icon>cancel</mat-icon>
          </button>
        }
        <valumize-card-comments-button [commentSlug]="'asset-swot'"></valumize-card-comments-button>
      </mat-card-actions>
    }
  </mat-card>
</form>
